export enum ItemTypesEnum {
  shipments = 'shipment-identifier',
  keys = 'reference-key',
  orders = 'order-identifier',
  identifiers = 'additional-identifier',
  tags = 'tags',
}
